var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shipment-item-proposals-item-group"},[_c('div',{staticClass:"fs-13 shipment-item-proposals-item-group__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"tw-text-blue-500",class:{
      'tw-font-medium': _vm.highlighted
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }